import { environment } from '@env'
import { PlatformType } from '@core/enums/application.enums'
import { StaticOrientation } from '@core/enums/statics.enum'
import { firstLetterToLowerCase } from '@mediacoach/ui'

// PATH
const IMAGES_PATH = `${environment.staticsUrlLocal}images/`
export const PLAYER_PLACEHOLDER_IMAGE = `${IMAGES_PATH}default-player.svg`

export const BRAND_LOGO = `${IMAGES_PATH}brand.png`

const APK_PATH = environment.staticsUrlCloud + firstLetterToLowerCase('Mobile/')

export const APK_PATH_BY_OS = {
  [PlatformType.Android]: `${APK_PATH}Android/PerformanceMobile.apk`,
  [PlatformType.Ios]: `itms-services://?action=download-manifest&url=${APK_PATH}iOS/manifest.plist`
}

// STATIC
export const STATIC_ORIENTATION_MAP = {
  [StaticOrientation.Landscape]: 'logo',
  [StaticOrientation.Portrait]: 'portraitLogo',
  default: 'defaultLogo'
}
